import { Alert, Row, Col } from "react-bootstrap";
import { useEffect, useState } from "react";

export const Newsletter = ({ onValidated, status, message }) => {
  const [email, setEmail] = useState("");

  const onSubmit = (e) => {
    e.preventDefault();
    alert("This is an example webpage, thank you for checking it out :)");
    clearFields();
  };

  const clearFields = () => setEmail("");

  return (
    <Col lg={12}>
      <div className="newsletter-bx">
        <Row>
          <Col lg={12} xl={5}>
            <h3>Subscribe for updates and exclusive photography insights!</h3>
          </Col>
          <Col lg={12} xl={7}>
            <form onSubmit={onSubmit}>
              <div className="new-email-bx">
                <input
                  value={email}
                  type="email"
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Email Address"
                ></input>
                <button type="submit">Submit</button>
              </div>
            </form>
          </Col>
        </Row>
      </div>
    </Col>
  );
};
